import React from 'react';
import { imageLinks } from 'assets/images';
import Svg from 'components/utils/Svg/Svg';
import "./ChatWidgetWelcome.scss";
import ClosePrompt from 'components/utils/ClosePrompt/ClosePrompt';

interface ChatWidgetProps {
    closeWidget: () => void;
    setIsHomeScreen: (value: boolean) => void;
}

const ChatWidgetWelcome: React.FC<ChatWidgetProps> = ({ closeWidget, setIsHomeScreen }) => {

    const approvedChannel = [
        {
            name: "Facebook",
            icon: imageLinks?.icon?.facebookMessenger
        },
        {
            name: "Whatsapp",
            icon: imageLinks?.icon?.whatsapp
        },
        {
            name: "Telegram",
            icon: imageLinks?.icon?.telegram
        },
        {
            name: "mtnApp",
            icon: imageLinks?.icon?.mtnApp
        }
    ]
    return (
        <div>
            <div className="widget__top">
                <img alt="Zigi" src={imageLinks.logo} className='widget__logo'/>

                <div className='welcome__group'>
                    <h4 className='brand__name'>{`Y'ello 👋🏾!`}</h4>
                    <p>
                        {`I'm Zigi, your MTN online
                        assistant 👩🏾‍💻.`}
                        {` What can I help you
                        with today?`}
                        <br />
                       
                    </p>
                    <p> {`I'm here and happy to assist 😀.`}</p>
                </div>
                <ClosePrompt closeWidget={closeWidget} />
            </div>
            <div className="widget__social">
                <button className="btn btn__primary btn__start__conversation" onClick={() => setIsHomeScreen(false)}>
                    <Svg src={imageLinks?.icon?.sendIcon} />
                    <span>Start a New Conversation</span>
                </button>
                <div className="chat__channels">
                    {
                        approvedChannel.map(({ icon, name }, index) => (
                            <Svg
                                src={icon}
                                key={index}
                                title={name}
                            />
                        ))
                    }
                </div>
            </div>
        </div>
    );
};

export default ChatWidgetWelcome;